import * as Sentry from '@sentry/nextjs';
import type { Integration, Options } from '@sentry/types';
import type { MonitoringRuntime } from './env';
import { getSentryInitOptions } from './env';

export function initSentry(runtime: MonitoringRuntime) {
  const options = getSentryInitOptions(runtime);
  if (!options) return;
  const replaySessionRate = options.replaysSessionSampleRate ?? 0;
  const replayOnErrorRate = options.replaysOnErrorSampleRate ?? 0;
  const replayMaskAllText = options.replayMaskAllText ?? true;
  const replayBlockAllMedia = options.replayBlockAllMedia ?? true;

  const { replayMaskAllText: _, replayBlockAllMedia: __, ...baseOptions } = options;
  const initOptions: Options = { ...baseOptions };

  if (runtime === 'client' && (replaySessionRate > 0 || replayOnErrorRate > 0)) {
    let replayIntegration: ((opts?: Record<string, unknown>) => Integration) | null = null;
    try {
      const browser = require('@sentry/browser') as {
        replayIntegration?: (opts?: Record<string, unknown>) => Integration;
      };
      replayIntegration = browser.replayIntegration ?? null;
    } catch {
      replayIntegration = null;
    }

    if (replayIntegration) {
      const existingIntegrations = Array.isArray(initOptions.integrations)
        ? initOptions.integrations
        : [];
      initOptions.integrations = [
        ...existingIntegrations,
        replayIntegration({
          maskAllText: replayMaskAllText,
          blockAllMedia: replayBlockAllMedia,
        }),
      ];
    }
  }

  Sentry.init(initOptions);
}
